import React from 'react';
import { useSelector } from 'react-redux';
import Registration from './Registration';
import { selectSessionUser } from '../../../state/ui/application/sessionUiReducer';
import RegistrationWizard from './RegistrationWizard';

export default function RegistrationPage() {
  const sessionUser = useSelector(selectSessionUser);

  // Normally we cannot access the Registration page while being signed in.
  // Except if we register a new account while not authenticated.
  // In this scenario we want to then go through the registration  wizard.
  if (sessionUser) return <RegistrationWizard />;

  return <Registration />;
}
